import { render, staticRenderFns } from "./ContactPreferencesCardLaBalaguere.vue?vue&type=template&id=5caffe5a"
import script from "./ContactPreferencesCardLaBalaguere.vue?vue&type=script&lang=js"
export * from "./ContactPreferencesCardLaBalaguere.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports